import { unref, type Ref } from "vue";

export default defineNuxtPlugin((nuxtApp) => {
  const businessStore = useBusinessStore();
  const { business } = storeToRefs(businessStore);

  return {
    provide: {
      formatPrice: (
        price: number | string | undefined | null,
        currency?: string
      ) => {
        if (price === undefined || price === null || price === "") {
          return "";
        }
        const i18n = (
          nuxtApp as unknown as {
            $i18n?: { locale?: string | Ref<string> };
          }
        ).$i18n;
        const locale = unref(i18n?.locale) || "en";
        const unit = (currency ?? business.value?.currency ?? "").trim();
        const isArabic = locale === "ar" || locale.startsWith("ar");
        return isArabic
          ? `${price} ${unit}`.trim()
          : `${unit} ${price}`.trim();
      },
    },
  };
});
